import React, {ReactElement} from "react";
import {Navigate, Route} from "react-router-dom";
import StreamInfoPage from "../../pages/chase/stream/StreamInfoPage";
import PokemonStreamPage from "../../pages/chase/stream/pokemon/PokemonStreamPage";
import PokemonPlayerPage from "../../pages/chase/stream/pokemon/gym-challenge/player/PokemonPlayerPage";
import SarStreamPage from "../../pages/chase/stream/sar/SarStreamPage";
import CharityStreamPage from "../../pages/chase/stream/charity/CharityStreamPage";
import PokemonGymStreamPage from "../../pages/chase/stream/pokemon/gym-challenge/PokemonGymStreamPage";
import AlsCharityStreamPage from "../../pages/chase/stream/charity/als/AlsCharityStreamPage";
import GoCharityStreamPage from "../../pages/chase/stream/charity/go/GoCharityStreamPage";
import SarCharacterStreamPage from "../../pages/chase/stream/sar/characters/SarCharacterStreamPage";
import KkaCharityStreamPage from "../../pages/chase/stream/charity/kka/KkaCharityStreamPage";
import BluerockBayPage from "../../pages/chase/stream/brb/BluerockBayPage";
import MarioStreamPage from "../../pages/chase/stream/mario/MarioStreamPage";
import VixyStreamPage from "../../pages/chase/stream/vixy/VixyStreamPage";

class StreamRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="stream">
                    <Route index element={<StreamInfoPage/>}/>
                    <Route path="bluerock" element={<BluerockBayPage/>}/>
                    <Route path="vixy" element={<VixyStreamPage/>}/>
                    <Route path="mario" element={<MarioStreamPage/>}/>
                    <Route path="pokemon">
                        <Route index element={<PokemonStreamPage/>}/>
                        <Route path="gym-challenge">
                            <Route index element={<PokemonGymStreamPage/>}/>
                            <Route path="players">
                                <Route index element={<Navigate to="/stream/pokemon/gym-challenge"/>}/>
                                <Route path=":player" element={<PokemonPlayerPage/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="sar">
                        <Route index element={<SarStreamPage/>}/>
                        <Route path="characters" element={<SarCharacterStreamPage/>}/>
                    </Route>
                    <Route path="charities">
                        <Route index element={<CharityStreamPage/>}/>
                        <Route path="als">
                            <Route index element={<AlsCharityStreamPage/>}/>
                        </Route>
                        <Route path="go">
                            <Route index element={<GoCharityStreamPage/>}/>
                        </Route>
                        <Route path="kka">
                            <Route index element={<KkaCharityStreamPage/>}/>
                        </Route>
                    </Route>
                </Route>
            </>
        );
    }
}

export default StreamRouter;